import request from '@/utils/requests';

const getters = {
  getCompanies: (state) => state.companies,
  isFetchingCompanies: (state) => state.isFetchingCompanies,
  getParentCompanies: (state) => state.parentCompanies,
  isFetchingParentCompanies: (state) => state.isFetchingParentCompanies,
};

const mutations = {
  SET_COMPANIES: (state, companies) => {
    state.companies = companies;
  },

  SET_IS_FETCHING_COMPANIES: (state, isFetchingCompanies) => {
    state.isFetchingCompanies = isFetchingCompanies;
  },

  SET_PARENT_COMPANIES: (state, parentCompanies) => {
    state.parentCompanies = parentCompanies;
  },

  SET_IS_FETCHING_PARENT_COMPANIES: (state, isFetchingParentCompanies) => {
    state.isFetchingParentCompanies = isFetchingParentCompanies;
  },
};

const actions = {
  fetchCompanies: async ({ rootGetters, commit }) => {
    let promiseResult;

    try {
      commit('SET_IS_FETCHING_COMPANIES', true);
      const response = await request('GET', 'admin/companies', rootGetters['auth/getToken']);
      commit('SET_COMPANIES', response.data.items);
      promiseResult = Promise.resolve();
    } catch (e) {
      promiseResult = Promise.reject(e);
    } finally {
      commit('SET_IS_FETCHING_COMPANIES', false);
    }

    return promiseResult;
  },

  fetchParentCompanies: async ({ rootGetters, commit }) => {
    let promiseResult;

    try {
      commit('SET_IS_FETCHING_PARENT_COMPANIES', true);
      const response = await request('GET', 'admin/companies?is_parent_company=true', rootGetters['auth/getToken']);
      commit('SET_PARENT_COMPANIES', response.data.items);
      promiseResult = Promise.resolve();
    } catch (e) {
      promiseResult = Promise.reject(e);
    } finally {
      commit('SET_IS_FETCHING_PARENT_COMPANIES', false);
    }

    return promiseResult;
  },

  updateCompany: async ({ rootGetters }, { companyId, body }) => {
    try {
      const response = await request(
        'PUT',
        `admin/companies/${companyId}`,
        rootGetters['auth/getToken'],
        body
      );
      return Promise.resolve(response.data);
    } catch (e) {
      return Promise.reject(e);
    }
  },

  updateParentCompany: async ({ rootGetters }, { companyId, body }) => {
    try {
      const response = await request(
        'PUT',
        `admin/companies/${companyId}`,
        rootGetters['auth/getToken'],
        body
      );
      return Promise.resolve(response.data);
    } catch (e) {
      return Promise.reject(e);
    }
  },

  fetchCompanySubscriptionHistory: async ({ rootGetters }, companyId) => {
    try {
      const response = await request(
        'GET',
        `admin/companies/${companyId}/subscription-history`,
        rootGetters['auth/getToken']
      );
      return Promise.resolve(response.data);
    } catch (e) {
      return Promise.reject(e);
    }
  },

  assignSubscriptionPlan: async ({ rootGetters }, { companyId, payload }) => {
    try {
      const response = await request(
        'POST',
        `admin/companies/${companyId}/assign-subscription-plan`,
        rootGetters['auth/getToken'],
        payload,
        {}
      );
      return Promise.resolve(response.data);
    } catch (e) {
      return Promise.reject(e);
    }
  },

  extendCompanySubscription: async ({ rootGetters }, companyId) => {
    try {
      const response = await request(
        'POST',
        `admin/companies/${companyId}/extend-subscription`,
        rootGetters['auth/getToken'],
        {},
        {}
      );
      return Promise.resolve(response.data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
};

const state = {
  companies: [],
  isFetchingCompanies: false,
  parentCompanies: [],
  isFetchingParentCompanies: false,
};

const modules = {};

export default {
  namespaced: true,
  getters,
  mutations,
  actions,
  modules,
  state,
};
